import { atom } from 'jotai';

export const selectedTeamIdAtom = atom<string | null>(null as string | null);
